/**
 * @file MainContent.js
 * @author marie filbey<m@soltech.net>
 * 
 * @fileoverview This file does this and that and this.
 */
import React, { Component } from 'react';
// import Loader from 'react-loader';
// import PropTypes from 'prop-types'
// import ReactDOM from 'react-dom'
// import { createStore } from 'redux'
// import { Provider, connect } from 'react-redux'

import Header from './Header';
import Map from './Map';
import Requirements from './Requirements';
import Dropdown from './Dropdown';
import Instructions from './Instructions';

class MainContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      questions: [],
      jurisdictions: [],
      filteredStates: [],
      licenseTypeID: 1,
      isActive: false,
      activeIndex: 1,
      selectedLicenseType: {},
      selectedUSState: undefined,
      activeMapLink: true,
      activeListLink: false,
      openSubHeader: false,
      loaded: false
    }

    this.handleLicenseTypeChange = this.handleLicenseTypeChange.bind(this);
    this.toggleLicenseTypeColor = this.toggleLicenseTypeColor.bind(this);
  }


  componentWillMount() {
    let id = this.state.licenseTypeID;
    this.fetchQuestionsByLicenseType(id);
    this.fetchMapQuestions(id);
  }

  fetchMapQuestions(id)
  {
    fetch(`${process.env.REACT_APP_API_URL}/api/licensing/${id}/mapviewquestions`)
    .then(function (response) {
      // console.log(response)
      return response.json();
    })
    .then((data) => {
      this.setState({
        questions: data.Questions,
        loaded: true
      })
    })
    .catch(function (error) {
      console.log(error);
    })
    
  }

  handleLicenseTypeChange(e) {
    console.log(e.target);
    this.filterLicenseType(e);
    this.fetchMapQuestions(e.target.id)
    this.toggleLicenseTypeColor(e.target.id);
    this.highlightApplicableQuestions(this.state.selectedUSState);
    this.setState({
      filteredStates: []
    })
    
  }


  render() {
    // console.log(this.state.data);
    return (
      <div className="App">
        <div className="row header-wrapper">
          <Header data={this.state.data} handleLicenseTypeChange={this.handleLicenseTypeChange} activeIndex={this.state.activeIndex} activeMapLink={this.state.activeMapLink} activeListLink={this.state.activeListLink} openSubHeader={this.state.openSubHeader}/>
        </div>

        <div className="step-one">Step 3: Select a jurisdiction to learn more about their specific licensing requirements.</div>
        {/* ----------Requirements, Jurisdiction, and Map Portion of Page--------- */}
        <div className="main-content-wrapper">
          <div className="row">
            <div className="page-left-wrapper col-4">
              <div className="question-list-wrapper">
                <p className="requirements-title">Requirements</p>
                {/* <Loader loaded={this.state.loaded}> */}
                  <Requirements licenseTypeID={this.state.licenseTypeID} filteredStates={this.state.filteredStates} questions={this.state.questions} />
                {/* </Loader> */}
              </div>
            </div>
            <div className="page-right-wrapper col-5">
              <div className="page-right-top-content">
                <div>
                  <div>
                    <p className="jurisdiction-title">Jurisdictions</p>
                  </div>
                  <Dropdown states={this.state.data} jurisdictions={this.state.jurisdictions} highlightApplicableQuestions={this.highlightApplicableQuestions} onSelectUSState={this.handleSelectUSState} selectedUSState={this.state.selectedUSState} />
                </div>
              </div>
              <Map data={this.state.data} questions={this.state.questions} highlightApplicableQuestions={this.highlightApplicableQuestions} onSelectUSState={this.handleSelectUSState} selectedUSState={this.state.selectedUSState} />
              <div className="instructions-map-view"><Instructions /></div>
            </div>

          </div>
        </div>
        {/* --------End of Requirements and Map -------- */}
      </div>
    );
  }

  //parent fetch 
  fetchQuestionsByLicenseType(id) {
    //these are the id's of the psychological associate sub nav
    let openSubHeader = (id === "-1" || id === "4" || id === "5" || id === "6" || id === "7")
    this.setState({
      openSubHeader
    })
    //-1 is the id for the 'fake psychological associate"
    if (id !== "-1") {
      this.fetchQuestions(id)
    } 
  }

  fetchQuestions(id) {
    fetch(`${process.env.REACT_APP_API_URL}/api/licensing/${id}/jurisdictionquestions`)
      .then(function (response) {
        return response.json();
      })
      .then((data) => {
        // console.log("List of states with Question Ids are", data);
        const filteredJurisdictions = data.filter((s) => {
          if ( s.questionIds.length > 0 ) {
            return s.jurisdictionName
          }
        })
        // console.log(filteredJurisdictions);
        this.setState({
          data: data,
          loaded: true,
          jurisdictions: filteredJurisdictions
        })
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  filterLicenseType(e) {
    this.setState({
      licenseTypeID: e.target.id,
      selectedUSState: ''
    })
    let id = e.target.id;
    this.fetchQuestionsByLicenseType(id);
  }

  highlightApplicableQuestions = (stateCode) => {
    const filteredStates = this.state.data.filter(row => stateCode === row.jurisdiction);
    // console.log(this.state.data);
    // console.log(filteredStates);
    this.setState({
      filteredStates
      // highlight: true
    });
  }

  toggleLicenseTypeColor = (id) => {
    // console.log(id)
    this.setState({
      activeIndex: +id
    })
  }

  handleSelectUSState = (stateCode) => {
    // console.log(stateCode);
    this.setState({
      selectedUSState: stateCode
    });
    this.highlightApplicableQuestions(stateCode);
  }
}

export default MainContent;



// WEBPACK FOOTER //
// ./src/components/MainContent.js